import { Date } from '../typo/Typo'
import listImage from '../../../assets/test-images/card-test.jpg'


const ListVideo = props => {
    return (
        <div className={`d-list d-list-video${props.player ? ' d-list-player' : ''}`}>
            <div className="d-list-visual ratio ratio-3x2">
                { props.player ? player(props) : image(props) }
            </div>
            <div className="d-list-content">
                <h5 className="title-link">
                    <a href="#!">{ props.title || 'Lorem ipsum dolor sit amet' }</a>
                </h5>
                <Date>{ props.date || '26/06/2020' }</Date>
                <p>{ props.text || 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque autem corrupti consequuntur tempore. Numquam, facere? Natus nisi aliquid a cumque, incidunt deleniti atque quibusdam adipisci recusandae repellendus labore. Neque, placeat.' }</p>
            </div>
        </div>
    );
}

const image = props => {
    return(
        <a href="#!"><img src={ props.image || listImage} alt={ props.title || 'Lorem ipsum dolor sit amet' } /></a>
    );
}

const player = props => {
    return(
        <iframe src="https://www.youtube.com/embed/WeoIsjYBQH0?controls=0" title="iframe1" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen=""></iframe>
    );
}

  
export default ListVideo;
